import { Box } from '@fhs-legacy/universal-components';
import Link from 'components/link';
import { WEB_APP_DESKTOP_LG_MAX_WIDTH } from 'utils/constants';

export const SectionContainer = Box.withConfig({
  background: {
    base: 'white',
    desktop: 'transparent',
  },
  width: 'full',
  maxWidth: {
    desktop: WEB_APP_DESKTOP_LG_MAX_WIDTH,
  },
  paddingTop: '$6',
  paddingLeft: { base: '$4', desktop: '$0' },
  marginX: 'auto',
  marginBottom: '$5',
  minHeight: '$4',
});

export const HeaderLink = Link.withConfig({
  marginLeft: '$3',
  marginRight: '$3',
  height: {
    desktop: 'full',
  },
  justifyContent: {
    desktop: 'center',
  },
  _text: {
    fontSize: 'sm',
    textTransform: 'capitalize',
  },
  position: { desktop: 'absolute' },
  right: '0',
});

export const HeaderTextWrapper = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'baseline',
  justifyContent: {
    desktop: 'center',
    base: 'space-between',
  },
});

export const IconWrapper = Box.withConfig({
  marginLeft: '$2',
});
